import * as React from 'react';
import { connect } from 'react-redux';
import { Action, bindActionCreators, Dispatch } from 'redux';
import {
  apiStatuses,
  fetchCustomerServiceInfo,
  windowUuid
} from '../actions/Actions';
import { IProductInfo, IUserInfo } from '../CustomTypes';
import { svgInfoPhone } from '../icons';
import { sccPulseTrackPageView } from '../PulseUtils';
import './ErrorMessage.scss';

export interface IStateProps {
  // tslint:disable:no-any
  customerServiceInfo?: any;
  productId?: number;
  productInfo?: IProductInfo;
  error?: boolean;
  errorJson?: string;
  errorStateName?: string;
  errorSummary?: string;
  message?: string;
  requestUuid?: string;
  requestUrl?: string;
  response?: string;
  status?: number;
  userInfo?: IUserInfo;
}

export interface IErrorMessageDispatchProps {
  fetchCustomerServiceInfo?: () => (dispatch: Dispatch<Action>) => any;
}

export interface IErrorMessageProps
  extends IErrorMessageDispatchProps,
    IStateProps {}

export class ErrorMessage extends React.Component<IErrorMessageProps, {}> {
  constructor(props: IErrorMessageProps) {
    super(props);
  }

  public componentDidMount() {
    this.props.fetchCustomerServiceInfo();
  }

  public render() {
    const {
      error,
      errorJson,
      errorSummary,
      message,
      status,
      errorStateName,
      requestUuid
    } = this.props;
    const { phoneNumber, customerserviceEmail } = this.props.productInfo;
    const maintenancePhone = this.props.customerServiceInfo[
      'customerservice.phone'
    ];
    const maintenanceEmail =
      this.props.customerServiceInfo['customerservice.email.url'] || '';

    if (error) {
      const uuid = windowUuid();
      const eventName = 'Error message';
      const productInfoWithIdFromUrl = {
        ...this.props.productInfo,
        subscriptionConfigurationId: this.props.productId
      };
      sccPulseTrackPageView(
        productInfoWithIdFromUrl,
        this.props.userInfo,
        eventName,
        {
          currentUrl: window.location.href,
          errorStateName,
          errorSummary,
          httpStatusCode: status,
          message,
          requestUuid,
          windowUuid: uuid
        }
      );
    }

    let body: any = message || (
      <p>
        {' '}
        Vi klarte ikke å behandle din forespørsel. <br />
        Vennligst prøv igjen eller ta kontakt med kundesenteret hvis feilen
        vedvarer.
      </p>
    );

    let header: string = errorSummary || 'Noe gikk galt';

    if (
      status &&
      status === 404 &&
      errorJson &&
      JSON.stringify(errorJson).indexOf('SUBSCRIPTION_TYPE_NOT_ACTIVE') > -1
    ) {
      header = 'Produkt er ikke lengre aktivt';
      body = <p>Vennligst gå tilbake og velg et annet produkt</p>;
    }

    return error ? (
      <div className="maintenance">
        <img
          className="icon_settings"
          src="https://kundewebtest.aftenposten.no/s/ff/img/logos/feilmelding_ill.svg"
        />
        <div className="talk-bubble tri-btm-left border round">
          <div className="talktext">
            <h1>{header}</h1>
            <p>{body}</p>
          </div>
        </div>
        <div className="contact-info">
          <p className="contact-title">Ring kundesenter</p>
          <div className="phone-number">
            {svgInfoPhone(25)}
            <p className="contact-phone-number">
              {phoneNumber || maintenancePhone}
            </p>
          </div>
          <div className="opening-hours">
            <small>
              man-fre(07-17)<br />lør(08-11)
            </small>
          </div>
          <p className="contact-title">Eller send oss en mail:</p>
          <a
            className="contact-email"
            href={`mailto:${customerserviceEmail ||
              maintenanceEmail.split(':')[1]}`}
          >
            {customerserviceEmail || maintenanceEmail.split(':')[1]}
          </a>
        </div>
      </div>
    ) : null;
  }
}

// tslint:disable:no-any
const mapStateToProps = (state: any) => {
  const errorStateName = Object.keys(state)
    .filter(
      k =>
        [
          'paymentMethodsInfo',
          'sessionInfo',
          'siebelInfo',
          'findUserByEmail',
          'checkCode',
          'findUserByPhoneNumber',
          'checkDuplicateAndQuarantine',
          'addFamilySharing'
        ].indexOf(k) === -1
    )
    .find(k => state[k].apiStatus && state[k].apiStatus === apiStatuses.ERROR);
  const errorData =
    (errorStateName && state[errorStateName].data) ||
    JSON.stringify(state[errorStateName], null, 2);
  const response =
    (errorStateName && state[errorStateName].response) ||
    JSON.stringify(state[errorStateName], null, 2);
  const requestUuid =
    (errorStateName && state[errorStateName].requestUuid) || '';
  const requestUrl = (errorStateName && state[errorStateName].requestUrl) || '';
  const status = errorStateName && state[errorStateName].status;
  let errorJson: {
    summary?: string;
    message?: string;
  } = {};
  if (errorData) {
    try {
      errorJson = errorData && JSON.parse(errorData);
    } catch (e) {
      // ignored...
    }
  }

  return {
    customerServiceInfo: state.customerServiceInfo,
    error: !!response,
    errorJson,
    errorStateName,
    errorSummary: errorJson.summary || '',
    message: errorJson.message,
    productId: state.router.params.productId,
    productInfo: state.productInfo,
    requestUrl,
    requestUuid,
    response,
    status,
    userInfo: state.userInfo
  } as IStateProps;
};

// tslint:disable:no-any
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchCustomerServiceInfo: () => fetchCustomerServiceInfo()
    },
    dispatch
  ) as IErrorMessageDispatchProps;

export default connect(mapStateToProps, mapDispatchToProps)(ErrorMessage);



// WEBPACK FOOTER //
// ./src/layout-components/ErrorMessage.tsx